import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const http = axios.create({
    baseURL: API,
});

// Attach Bearer token from localStorage if present (fallback to cookie auth)
http.interceptors.request.use((config) => {
    const token = localStorage.getItem("admin_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export function formatError(err) {
    const d = err?.response?.data?.detail;
    if (!d) return err?.message || "Une erreur est survenue.";
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" — ");
    return String(d);
}

export default http;
export { API };
